<template>
    <div class="col-12">
        <div class="row no-gutters justify-content-start ml-2">
            <div class="col-11">
                <div class="row no-gutters align-items-center my-1">
                    <div class="col-8 horse-details-wrapper my-3">
                        <div class="row no-gutters">
                            <span class="font-weight-bold font-italic horse-name">SILVANO</span>
                        </div>
                        <span class="row no-gutters font-italic horse-details-text">30:8-2-5</span>
                    </div>
                </div>
                <div class="row no-gutters d-flex justify-content-space-evenly my-3">
                    <button class="col-5 col-xl-2 filter-button">All Distances</button>
                    <button class="col-5 col-xl-2 filter-button">All Ages</button>
                    <button class="col-5 col-xl-2 filter-button">All Goings</button>
                    <button class="col-5 col-xl-2 filter-button">All Surfaces</button>
                    <button class="col-5 col-xl-1 filter-tag">Filter</button>
                </div>
            </div>
        </div>
        <div class="row no-gutters justify-content-center">
            <div class="col-12">
                <div class="row no-gutters justify-content-space-evenly team-details-table">
                    <div style="position: relative;" class="col-12 px-1">
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="thead-dark">
                                <tr>
                                    <th scope="col">DATE</th>
                                    <th scope="col">CRS</th>
                                    <th class="d-none d-xl-table-cell" scope="col">REF</th>
                                    <th scope="col">RACE</th>
                                    <th scope="col">DIST</th>
                                    <th scope="col">HORSE</th>
                                    <th scope="col">TRAINER</th>
                                    <th scope="col">MR</th>
                                    <th scope="col">WGT</th>
                                    <th scope="col">DRAW</th>
                                    <th scope="col">POS</th>
                                    <th scope="col">LTH</th>
                                    <th scope="col">TIME</th>
                                    <th scope="col">ADJ/TM</th>
                                    <th scope="col">OB</th>
                                    <th scope="col">SP</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td scope="row">21.03.18</td>
                                    <td class="highlighted-table-cell">F</td>
                                    <td class="d-none d-xl-table-cell">328G</td>
                                    <td>JP-F</td>
                                    <td>1200s</td>
                                    <td>BOLD VIKING</td>
                                    <td>Sean Tarry</td>
                                    <td class="font-weight-bold">63</td>
                                    <td>51,5kg</td>
                                    <td>3/12</td>
                                    <td class="text-center"><img :src="getImage('wf-finishing-position-1')" class="finishing-position-icon" v-on:click="toggleFormGridVisibility()"></td>
                                    <td>1,25</td>
                                    <td>102.94</td>
                                    <td>104.67</td>
                                    <td><sup>8</sup>&frasl;<sub>1</sub></td>
                                    <td><sup>13</sup>&frasl;<sub>1</sub></td>
                                </tr>
                                <tr>
                                    <td scope="row">21.03.18</td>
                                    <td class="highlighted-table-cell">F</td>
                                    <td class="d-none d-xl-table-cell">328G</td>
                                    <td>JP-F</td>
                                    <td>1200s</td>
                                    <td>BOLD VIKING</td>
                                    <td>Sean Tarry</td>
                                    <td class="font-weight-bold">63</td>
                                    <td>51,5kg</td>
                                    <td>3/12</td>
                                    <td class="text-center"><img :src="getImage('wf-finishing-position-2')" class="finishing-position-icon" v-on:click="toggleFormGridVisibility()"></td>
                                    <td>1,25</td>
                                    <td>102.94</td>
                                    <td>104.67</td>
                                    <td><sup>8</sup>&frasl;<sub>1</sub></td>
                                    <td><sup>13</sup>&frasl;<sub>1</sub></td>
                                </tr>
                                <tr>
                                    <td scope="row">21.03.18</td>
                                    <td class="highlighted-table-cell">F</td>
                                    <td class="d-none d-xl-table-cell">328G</td>
                                    <td>JP-F</td>
                                    <td>1200s</td>
                                    <td>BOLD VIKING</td>
                                    <td>Sean Tarry</td>
                                    <td class="font-weight-bold">63</td>
                                    <td>51,5kg</td>
                                    <td>3/12</td>
                                    <td class="text-center"><img :src="getImage('wf-finishing-position-4')" class="finishing-position-icon" v-on:click="toggleFormGridVisibility()"></td>
                                    <td>1,25</td>
                                    <td>102.94</td>
                                    <td>104.67</td>
                                    <td><sup>8</sup>&frasl;<sub>1</sub></td>
                                    <td><sup>13</sup>&frasl;<sub>1</sub></td>
                                </tr>
                                <tr>
                                    <td scope="row">21.03.18</td>
                                    <td class="highlighted-table-cell">F</td>
                                    <td class="d-none d-xl-table-cell">328G</td>
                                    <td>JP-F</td>
                                    <td>1200s</td>
                                    <td>BOLD VIKING</td>
                                    <td>Sean Tarry</td>
                                    <td class="font-weight-bold">63</td>
                                    <td>51,5kg</td>
                                    <td>3/12</td>
                                    <td class="text-center">9</td>
                                    <td>1,25</td>
                                    <td>102.94</td>
                                    <td>104.67</td>
                                    <td><sup>8</sup>&frasl;<sub>1</sub></td>
                                    <td><sup>13</sup>&frasl;<sub>1</sub></td>
                                </tr>
                                <tr>
                                    <td scope="row">21.03.18</td>
                                    <td class="highlighted-table-cell">F</td>
                                    <td class="d-none d-xl-table-cell">328G</td>
                                    <td>JP-F</td>
                                    <td>1200s</td>
                                    <td>BOLD VIKING</td>
                                    <td>Sean Tarry</td>
                                    <td class="font-weight-bold">63</td>
                                    <td>51,5kg</td>
                                    <td>3/12</td>
                                    <td class="text-center"><img :src="getImage('wf-finishing-position-3')" class="finishing-position-icon" v-on:click="toggleFormGridVisibility()"></td>
                                    <td>1,25</td>
                                    <td>102.94</td>
                                    <td>104.67</td>
                                    <td><sup>8</sup>&frasl;<sub>1</sub></td>
                                    <td><sup>13</sup>&frasl;<sub>1</sub></td>
                                </tr>
                                <tr>
                                    <td scope="row">21.03.18</td>
                                    <td class="highlighted-table-cell">F</td>
                                    <td class="d-none d-xl-table-cell">328G</td>
                                    <td>JP-F</td>
                                    <td>1200s</td>
                                    <td>BOLD VIKING</td>
                                    <td>Sean Tarry</td>
                                    <td class="font-weight-bold">63</td>
                                    <td>51,5kg</td>
                                    <td>3/12</td>
                                    <td class="text-center"><img :src="getImage('wf-finishing-position-1')" class="finishing-position-icon" v-on:click="toggleFormGridVisibility()"></td>
                                    <td>1,25</td>
                                    <td>102.94</td>
                                    <td>104.67</td>
                                    <td><sup>8</sup>&frasl;<sub>1</sub></td>
                                    <td><sup>13</sup>&frasl;<sub>1</sub></td>
                                </tr>
                                <tr>
                                    <td scope="row">21.03.18</td>
                                    <td class="highlighted-table-cell">F</td>
                                    <td class="d-none d-xl-table-cell">328G</td>
                                    <td>JP-F</td>
                                    <td>1200s</td>
                                    <td>BOLD VIKING</td>
                                    <td>Sean Tarry</td>
                                    <td class="font-weight-bold">63</td>
                                    <td>51,5kg</td>
                                    <td>3/12</td>
                                    <td class="text-center">7</td>
                                    <td>1,25</td>
                                    <td>102.94</td>
                                    <td>104.67</td>
                                    <td><sup>8</sup>&frasl;<sub>1</sub></td>
                                    <td><sup>13</sup>&frasl;<sub>1</sub></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BreederStatistics',
        props: {
            selectedBreeder: Object,
            formGridToggleCallback: Function
        },
        methods: {
            getImage(imagePath, fileType) {
                if(fileType) return require('../assets/images/' + imagePath + '.' + fileType);
                return require('../assets/images/' + imagePath + '.svg');
            },
            toggleFormGridVisibility(selectedBreeder) {
                this.formGridToggleCallback(selectedBreeder);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table td {
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
    }

    .filter-button {
        border-radius: 5px;
        border: solid 1px #000000;
        background-color: #FFFFFF;
        margin-bottom: 0.4rem;
    }

    .filter-tag {
        background-color: #000000;
        color: #FFFFFF;
        border-radius: 5px;
        text-align: center;
        border: none;
    }

    .horse-name {
        font-size: 1.3rem;
    }

    .highlighted-table-cell {
        background-color: #f2f2f2;
    }

    .table-responsive {
        border: 1px solid #7c7c7c !important;
        margin-bottom: 0.5rem !important;
        box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
    }

    .team-details-table {
        margin-top: 0.6rem;
    }

    .finishing-position-icon {
        width: 1.4rem;
    }

    .horse-career-wrapper table {
        width: 100%;
        text-align: center;
    }

    .horse-career-wrapper td {
        font-size: 0.55rem;
    }

    .horse-details-text {
        font-size: 0.7rem;
    }

    @media (min-width: 768px) {
        .finishing-position-icon {
            width: 1.8rem;
        }
    }

    @media only screen and (min-device-width: 0px) and (max-device-width: 1200px) and (orientation: landscape) {
        .horse-career-wrapper td {
            font-size: 1rem;
        }

        .horse-name {
            font-size: 1.7rem;
        }
    }

    @media (min-width: 1200px) {
        .table td {
            padding-top: 0.75rem;
            padding-bottom: 0.75rem;
        }

        .horse-name {
            font-size: 2rem;
        }

        .horse-career-wrapper td {
            font-size: 1.1rem;
            line-height: 1.6rem;
            padding: 0 1rem;
        }

        .horse-details-text {
            font-size: 1.05rem;
        }
    }
</style>
